<template>
  <!-- -->
  <div class="site-detail" >
    <list-page>
      <list-table background-color="#FFF" class="list-table" :show-shadow="true">
        <form-tag label="基础信息"/>
        <form-items :columns="2" :data="dataDetail">
          <form-item label="项目名称" :required="true" name="projectId" error-message="请选择项目">
            <el-select  v-model="dataDetail.projectId" placeholder="请选择项目" @change="changeProject">
              <el-option v-for="item in projectList" :key="item.id" :value="item.id" :label="item.projectName" />
            </el-select>
          </form-item>
          <form-item label="默认考勤" :required="true" name="attendConfigId" error-message="请选择默认的考勤规则">
            <el-select v-model="dataDetail.attendConfigId">
              <el-option v-for="item in configList" :key="item.id" :value="item.id" :label="item.configName"/>
            </el-select>
          </form-item>
          <form-item label="工地名称" :required="true" name="siteName" error-message="请输入工地名称">
            <el-input v-model="dataDetail.siteName" placeholder="请输入工地名称"/>
          </form-item>
          <form-item label="负责人" :required="true" name="leader" error-message="请选择负责人">
            <employee-select v-model="dataDetail.leader"/>
          </form-item>
          <form-item label="项目阶段">
            <el-select v-model="dataDetail.sitePhase" placeholder="请选择项目阶段">
              <el-option v-for="item in projectStageList" :key="item.id" :value="item.dictCode" :label="item.dictName" />
            </el-select>
          </form-item>
          <form-item label="项目进度">
            <el-input v-model="dataDetail.progress" placeholder="请输入项目进度百分数">
              <template #suffix>%</template>
            </el-input>
          </form-item>
          <form-item label="计划时间">
            <date-range v-model:start-time="dataDetail.planStartTime" v-model:end-time="dataDetail.planEndTime" :show-short-cut="false"/>
          </form-item>
          <form-item label="实际时间">
            {{ getActualTimeStart }} 至 {{ getActualTimeEnd }}
          </form-item>
          <form-item label="工地进度">
            <el-select v-model="dataDetail.status" placeholder="请选择进度">
              <el-option label="未开始" :value="0"/>
              <el-option label="进行中" :value="1"/>
              <el-option label="已完成" :value="100"/>
            </el-select>
          </form-item>
          <form-item label="工地坐标">
            {{dataDetail.lng}},{{dataDetail.lat}}
          </form-item>
          <form-item label="工地位置">
            <el-input v-model="dataDetail.siteAddr" placeholder="请输入工地位置"/>
          </form-item>
          <form-item label="所属地区">
            <administrative v-model="dataDetail.regionCode" place-holder="请选择区域" />
          </form-item>
        </form-items>
        <form-tag label="定位信息"/>
        <div style="position: relative;height: 300px;">
          <tx-map :lat="dataDetail.lat" :lng="dataDetail.lng" :address="dataDetail.siteAddr" @getLocation="mapGetLocation" style="position: absolute"/>
        </div>
      </list-table>
      <form-page :show-page="false" :show-shadow="false">
        <page-button message="您确认开工吗？确认后无法变更！" v-if="dataDetail.status === 0" el-type="success" @click="changeActualTime('1')">开工</page-button>
        <page-button message="您确认完工吗？" v-if="dataDetail.status === 1" el-type="success" @click="changeActualTime('2')">完工</page-button>
        <page-button type="write" @click="save" el-type="primary">保存</page-button>
      </form-page>
    </list-page>

  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import Util from "@/util/util";
import DateRange from "@/components/h5/date/YqDateRange.vue";
import commonLqApi from "@/api/dz-luqiao/luqiaoCommonApi";
import siteApi from "@/api/dz-luqiao/luqiaoSiteApi";
import util from "@/util/util";
import commonApi from "@/api/commonApi";
import TxMap from "@/components/h5/map/TxMap.vue";
import Administrative from "@/components/h5/data/Administrative.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "SiteDetail",
  components: {
    Administrative,
    EmployeeSelect, DateRange,
    PageButton, ListPage, ListTable, FormPage, FormItems, FormItem, TxMap, FormTag
  },
  data() {
    return {
      colorCurrent: "#FF33FF",
      colorDefault: "#1791fc",
      projectStageList: [],
      dataDetail: {},
      activeName: "info",
      projectList: [],
      history: [],
      configList:[],
    };
  },
  computed: {
    getActualTimeStart(){
      if(!this.dataDetail.actualStartTime){
        return "";
      }
      return this.dataDetail.actualStartTime.split(" ")[0];
    },
    getActualTimeEnd(){
      if(!this.dataDetail.actualEndTime && this.dataDetail.actualStartTime){
        return "今天";
      }else if(!this.dataDetail.actualEndTime && !this.dataDetail.actualStartTime){
        return ""
      }
      return this.dataDetail.actualEndTime.split(" ")[0];
    }
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    await this.init();
    // 回显
    if(this.route.query.id){
      await this.findById(this.route.query.id)
      // 查询工地变更
      await this.loadMockHistory();
    }

  },
  unmounted() {
  },
  methods: {
    async init() {
      // 项目列表
      this.projectList = this.projectList.concat(await commonLqApi.queryProjectNoPage());
      if (this.route.query.projectId) {
        // 根据项目创建工地
        this.dataDetail.projectId = this.route.query.projectId;
        for (let i = 0; i < this.projectList.length; i++) {
          if (this.projectList[i].id === this.route.query.projectId) {
            this.dataDetail.attendConfigId = this.projectList[i].attendConfigId;
          }
        }
      }
      this.configList = await siteApi.queryAllAttendConfig();
      // 字典
      const userInfo = await util.getUserInfo()
      this.projectStageList = await commonApi.queryDictionaryList("PROJECT_PHASE", userInfo.merchantId)
    },
    async loadMockHistory(){
      // 使用前端假数据填充时间轴；后端接入后替换为接口数据
      const list = await siteApi.queryHistory(this.route.query.id);
      // 映射并按时间倒序显示
      // const mapped = (list || []).map(item => this.formatHistoryItem(item));
      this.history = list.sort((a,b) => new Date(b.operateTime) - new Date(a.operateTime));
    },
    async save(){
      this.dataDetail = await siteApi.saveSubmit(this.dataDetail)
    },
    async findById(id) {
      let data = await siteApi.findById(id);
      // 如果没有当前这个项目就加上
      let contains = false;
      for (let i = 0; i < this.projectList.length; i++) {
        if (this.projectList[i].id === data.projectId) {
          contains = true;
          break;
        }
      }
      if (!contains) {
        this.projectList = this.projectList.concat({id: data.projectId, projectName: data.projectName})
      }
      this.dataDetail = data;
    },
    async changeActualTime(type){
      if(!this.dataDetail.id){
        this.$message.error("请先保存！");
        return
      }
      if(type === "1" && this.dataDetail.actualStartTime){
        this.$message.error("已开始，请勿重复操作");
        return
      }
      await siteApi.changeActualTime(this.dataDetail.id, type)
      await this.findById(this.dataDetail.id)
      this.$message.success("操作成功");
    },
    getHistoryTypeInfo(historyType){
      const map = {
        // 工地/项目类
        SITE_CREATE: { name: "创建工地", desc: "创建了工地" },
        SITE_START: { name: "开工", desc: "项目开工" },
        SITE_FINISH: { name: "完工", desc: "项目完工" },
        SITE_PHASE_CHANGE: { name: "阶段变更", desc: "项目阶段变更" },

        // 验收/巡检
        ACCEPTANCE: { name: "验收", desc: "项目验收" },
        INSPECTION: { name: "工地巡检", desc: "工地巡检" },

        // 班组/人员
        CLASSMATE_JOIN: { name: "班组进场", desc: "班组进场" },
        CLASSMATE_LEAVE: { name: "班组离场", desc: "班组离场" },
        WORKER_JOIN: { name: "人员进场", desc: "人员进场" },
        WORKER_LEAVE: { name: "人员离场", desc: "人员离场" },
      };
      return map[historyType] || { name: historyType || "事件", desc: "发生事件" };
    },
    formatHistoryItem(raw){
      const info = this.getHistoryTypeInfo(raw.historyType);
      return {
        operatorTime: raw.operateTime || raw.operatorTime || "",
        operator: raw.operateName || raw.employeeName || raw.updatedName || "",
        content: info.desc,
        milepostName: info.name,
        images: raw.images || [],
        // 透传原字段以备后续使用
        _raw: raw,
      };
    },
    // 项目变更时
    changeProject() {
      if (this.dataDetail.projectId) {
        // 项目变更,如果已保存考勤，不变更
        if (this.dataDetail.attendConfigId && this.dataDetail.id) {
          // 已保存，有id，且有考勤数据
          return;
        }
        // 项目信息
        for (let i = 0; i < this.projectList.length; i++) {
          if (this.projectList[i].id === this.dataDetail.projectId) {
            if (!this.projectList[i].attendConfigId) {
              // 没有考勤
              return;
            }
            this.dataDetail.attendConfigId = this.projectList[i].attendConfigId;
            break;
          }
        }
      }
    },
    // 获取到定位的位置
    mapGetLocation({lat, lng, address, adCode}) {
      this.dataDetail.siteAddr = address;
      this.dataDetail.lat = lat;
      this.dataDetail.lng = lng;
      if (adCode) {
        this.dataDetail.regionCode = adCode + "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tabs";
.site-detail{
  height: 100%;
  .list-table{
    padding: 10px;
    display: flex;
    flex-direction: column;
    .a-map{
      flex: 1;
      height: 100px;
      position: relative;
      .gaode-map{
        height: calc(100% + 30px);
      }
      .options{
        position: absolute;
        z-index: 1;
        left: 10px;
        top: 10px;
      }
    }
  }
  .milepost{
    .milepost-section{
      & + .milepost-section{
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px dashed var(--yq-divider-color, #e5e5e5);
      }
      .section-title{
        font-weight: 600;
        margin-bottom: 6px;
      }
      .section-content{
        .milepost-time{
          color: var(--yq-font-color-desc);
          margin-top: 6px;
          font-size: var(--yq-font-size-small, 12px);
        }
        .milepost-operator{
          font-size: var(--yq-font-size-medium, 14px);
        }
      }
    }
    .milepost-name{
      font-size: var(--yq-font-size-large);
    }
    .milepost-desc{
      color: var(--yq-font-color-desc);
      margin: 10px 0;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }
}
:deep(.el-drawer){
  .el-drawer__title{
    font-size: 24px;
  }
}
:deep(.amap-maps){
  .amap-info-content{
    width: 400px;
    padding-top: 40px;
  }
  // .info-开头的是消息窗
  .info-title{
    position: absolute;
    top: 0;
    left: 0;
    height: 30px;
    width: 100%;
    background: #409eff;
    line-height: 30px;
    text-align: center;
    color: #FFF;
  }
  .info-marker{
    .geo{
      text-align: right;
      .button{
        color: #409eff;
        cursor: pointer;
        &:hover{
          color: #6AB5FF;
        }
      }
    }
  }
  .amap-info-close{
    color: #FFF;
  }

}
</style>